export default __webpack_public_path__ + "static/media/heroMobileBG.24ecc514.png";